import { ERROR_CODE_GENERAL } from "api/ApiPath";
import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { IErrorCodeGeneralRepository } from "features/errorCodeGeneralFeature/domain/repositories/IErrorCodeGeneralRepository";
import { injectable } from "tsyringe";
import { DataFormat } from "utils/format/DataFormat";
import { StringFormat } from "utils/format/StringFormat";
import { getMessage } from "utils/helpersInTs/helpersInTs";
import { DetailErrorCodeResponseModel } from "./model/DetailErrorCodeResponseModel";
import { ErrorCodeGeneralRequestModel } from "./model/ErrorCodeGeneralRequestModel";
import { ErrorCodeGeneralResponseModel } from "./model/ErrorCodeGeneralResponseModel";

@injectable()
export class ErrorCodeGeneralImpl implements IErrorCodeGeneralRepository {
  async fetchGeneral(
    params: ErrorCodeGeneralRequestModel,
  ): Promise<ListBaseApiResponseModel<ErrorCodeGeneralResponseModel>> {
    const url = StringFormat.buildListUrl<ErrorCodeGeneralRequestModel>(
      ERROR_CODE_GENERAL.ERROR_CODE,
      params,
    );
    const preparedParams = DataFormat.prepareParamsForApi(params);
    return await client?.get(url, preparedParams);
  }

  async fetchDetail(
    params: ErrorCodeGeneralRequestModel,
  ): Promise<ListBaseApiResponseModel<DetailErrorCodeResponseModel>> {
    const url = StringFormat.buildListUrl<ErrorCodeGeneralRequestModel>(
      ERROR_CODE_GENERAL.DETAIL_ERROR_CODE,
      params,
    );
    const preparedParams = DataFormat.prepareParamsForApi(params);
    return await client?.get(url, preparedParams);
  }

  async fetchReport(
    params: ErrorCodeGeneralRequestModel,
  ): Promise<BaseApiResponseModel<Blob>> {
    const url = StringFormat.buildExportUrl(
      ERROR_CODE_GENERAL.DETAIL_ERROR_CODE,
      params,
    );
    const token = DataFormat.getToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/xml",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorBody = await response.json();
      getMessage(errorBody["message"], 3, "error");
      return errorBody;
    }

    const blob = await response.blob();

    return {
      success: true,
      data: blob,
      message: "Export successful",
    } as unknown as BaseApiResponseModel<Blob>;
  }
}
